import { useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { fetchProductDetaill } from 'redux/actions/productActions'
import { QUERY_KEYS } from 'Utils/queryKeys'

export const useProductDetails = (
  { productId, companyId, warehouse },
  enabled = true
) => {
  const dispatch = useDispatch()
  return useQuery({
    queryKey: [QUERY_KEYS.PRODUCT_DETAIL, productId, warehouse],
    queryFn: async () => {
      const payload = {
        CompanyId: companyId,
        WarehouseId: warehouse,
        ProductId: productId,
        GlobalExecution: true,
        PriceListId: null,
      }

      const response = await dispatch(fetchProductDetaill(payload))
      const data = response?.data?.[0]
      if (!data) throw new Error('No product data found')
      return data
    },
    enabled,
    staleTime: 1000 * 60 * 60 * 8,
    cacheTime: 1000 * 60 * 60 * 8,
  })
}
